import React, { useCallback } from 'react';

import asBentoModule from 'common/bento/hoc/asBentoModule';
import withStateMachine from 'common/bento/hoc/withStateMachine/withStateMachine';
import assertNever from 'common/bento/lib/assertNever';
import stringifyState from 'common/bento/lib/stringifyState';

import OBLoaderPage from '../../components/OBLoaderPage/OBLoaderPage';
import machineConfig, { model, State } from './machine';
import Form from './pages/Form';
import Refused from './pages/Refused';

const CapitalDepositEUBankAccountComponent = withStateMachine<typeof model>(
  ({ machine, moduleData }) => {
    const [state, send] = machine;

    const onPrev = useCallback(() => {
      send(model.events.PREV());
    }, [send]);

    const stringifiedState = stringifyState<State>(state);
    const { isMandatee } = moduleData;

    switch (stringifiedState) {
      case State.FORM:
        return (
          <Form
            formData={state.context.formData}
            isMandatee={isMandatee}
            onPrev={onPrev}
            onSubmit={(values) => send(model.events.SUBMIT(values))}
          />
        );

      case State.REFUSED:
        return <Refused isMandatee={isMandatee} onPrev={onPrev} />;

      case State.DONE:
      case State.ABORT:
        return <OBLoaderPage onPrev={() => null} />;

      default:
        return assertNever(stringifiedState);
    }
  },
  {
    devTools: true,
    machineConfig,
  },
);

interface CapitalDepositEUBankAccountProps {
  isMandatee?: boolean; // If true, the locales will be adapted for a mandatee
}

const CapitalDepositEUBankAccount =
  asBentoModule<CapitalDepositEUBankAccountProps>(
    ({ isMandatee = false, onDone }) => (
      <CapitalDepositEUBankAccountComponent
        moduleData={{ isMandatee }}
        onDone={onDone}
      />
    ),
  );

export default CapitalDepositEUBankAccount;
